import { callMethod } from './api';

/**
 * Minimal `meteor/meteor` stand-in for the client. The only piece of the
 * Meteor global the Ops Command UI uses is `Meteor.callPromise`, which the
 * EventMapPopup and ScopeGroupsModal use for one-off method calls. Vite aliases
 * `meteor/meteor` to this module (see vite.config.ts), so the copied UI is
 * unchanged.
 */
const MeteorShim = {
  callPromise<T = any>(method: string, ...args: unknown[]): Promise<T> {
    return callMethod<T>(method, args);
  },
};

export { MeteorShim as Meteor };
